import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {PlantingIncome, PlantingIncomeDetail} from "@/types/Component";
import { CsvDownload, PlantingIncomeGet } from '@/types/APIResponse';
import { toCamel } from "snake-camel";

@Component({
    filters: {
        applyNumberFormat(value: number): string | null {
            return value.toLocaleString()
        },
        applyAmountFormat(value: number): string | null {
            return Math.round(value).toLocaleString().replace(/^-/, '▲')
        }
    }
})

export default class IncomeAndOutgoPlantingIncomeDetail extends Vue {
    @Prop()
    private cropId!: string

    @Prop()
    private plantingId!: string

    private responseItem: PlantingIncome | null = null
    private sortByAmountAsc = false
    private sortByDateAsc = false;
    private parentPath = `/management/income-and-outgo/crops/${this.cropId}`

    @Prop()
    private startDate!: string
    @Prop()
    private endDate!: string

    created(): void {
        this.getIncome()
    }

    private getIncome() {
        this.$apiClient.doRequest('get', `/admin/income_and_outgo/crops/income/${this.plantingId}?start_date=${this.startDate}&end_date=${this.endDate}`).then((ret: PlantingIncomeGet) => {
            this.responseItem = toCamel(ret) as PlantingIncome
            this.sortByDate();
        })
    }


    private sortByAmount(): void {
        this.sortByAmountAsc = !this.sortByAmountAsc
        this.responseItem?.details.sort((a, b) => {
            // null < 0 < amount として扱う（前提：amountには負の値が入らない）
            return this.sortByAmountAsc ?
                (a.amount ?? -1) - (b.amount ?? -1) : (b.amount ?? -1) - (a.amount ?? -1)
        })
    }

    private sortDateClicked() {
        this.sortByDateAsc = !this.sortByDateAsc;
        this.sortByDate();
    }

    private sortByDate() {
        this.responseItem?.details.sort((a, b) => this.compare(a, b))
    }

    private compare(a: PlantingIncomeDetail, b: PlantingIncomeDetail) {
        if (this.sortByDateAsc) {
            if (Date.parse(a.shippingDate) < Date.parse(b.shippingDate)) return -1;
            if (Date.parse(a.shippingDate) > Date.parse(b.shippingDate)) return 1;
            if (a.subject.localeCompare(b.subject, 'ja') < b.subject.localeCompare(a.subject, 'ja')) return -1;
            if (a.subject.localeCompare(b.subject, 'ja') > b.subject.localeCompare(a.subject, 'ja')) return 1;
            return 1;
        } else {
            if (Date.parse(b.shippingDate) < Date.parse(a.shippingDate)) return -1;
            if (Date.parse(b.shippingDate) > Date.parse(a.shippingDate)) return 1;
            if (b.subject.localeCompare(a.subject, 'ja') < a.subject.localeCompare(b.subject, 'ja')) return -1;
            if (b.subject.localeCompare(a.subject, 'ja') > a.subject.localeCompare(b.subject, 'ja')) return 1;
            return 1;
        }
    }

    private exportCsv(): void {
        this.$apiClient.getRequest(`/admin/income_and_outgo/crops/income/${this.plantingId}/csv_export?start_date=${this.startDate}&end_date=${this.endDate}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        })
    }
}